(function () {
  'use strict';

  const queue = [];
  let running = false;
  const debounceTimers = new Map();

  async function processQueue() {
    if (running) return;
    running = true;

    while (queue.length > 0) {
      const { fn, resolve, reject } = queue.shift();
      try {
        const result = await fn();
        resolve(result);
      } catch (err) {
        reject(err);
      }
    }

    running = false;
  }

  function enqueue(fn) {
    return new Promise((resolve, reject) => {
      queue.push({ fn, resolve, reject });
      processQueue();
    });
  }

  function debouncedEnqueue(key, fn, delay) {
    if (delay === undefined) delay = 300;

    if (debounceTimers.has(key)) {
      const prev = debounceTimers.get(key);
      clearTimeout(prev.timer);
      prev.resolve(null);
    }

    return new Promise((resolve, reject) => {
      const timer = setTimeout(function () {
        debounceTimers.delete(key);
        enqueue(fn).then(resolve).catch(reject);
      }, delay);

      debounceTimers.set(key, { timer, resolve, reject });
    });
  }

  window.CartQueue = {
    enqueue: enqueue,
    debouncedEnqueue: debouncedEnqueue,
    get busy() {
      return running;
    },
  };
})();
